export default ["M4 4h3.273c.401 0 .727.326.727.727v6.546a.727.727 0 01-.727.727H4a4 4 0 010-8zm12 4a4 4 0 01-4 4H9.636A.636.636 0 019 11.364V4.636C9 4.285 9.285 4 9.636 4H12a4 4 0 014 4zm-4-2h-1v4h1a2 2 0 100-4z"];
